<rc-order>
  <span order-heading>
    S-a produs o eroare
  </span>
  <span order-content>
  </span>
  <span thanks-heading>
        Ne pare rău pentru neplăcerile create.
    <br />
   Dacă întâmpinați probleme vă rugăm contactați-ne la <a  (click)="trackConversion('Pv7pCN3In6QZELWMoq4q')" href="tel:0740101510">0740 101 510</a> / <a href="mailto:vanzari@experttabla.ro">vanzari@experttabla.ro</a>
  </span>
</rc-order>
